/* eslint-disable prettier/prettier */
import { useState, useEffect } from "react";
import { Row, Col } from "antd";
import InputForm from "./utils/InputForm";
import { AddFetchMarcaAtb } from "../Api/Administracion/AddFetchMarcaAtb";
import { PutFetchMarcaAtb } from "../Api/Administracion/PutFetchMarcaAtb";

export const AdministrationAtbAddMarca = ({
  selectedItem,
  fetchData,
  setShowModal,
  //marca,
  modalKey,
}) => {
  const objDefault = {
    FIMARCAATBID: 0,
    FCNOMBREMARCA: "",
    FIESTATUS: 1,
  };
  const [formData, setFormData] = useState(objDefault);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (selectedItem) {
      const newObj = {
        FIMARCAATBID: selectedItem.FIMARCAATBID,
        FCNOMBREMARCA: selectedItem.FCNOMBREMARCA,
        FIESTATUS: selectedItem.FIESTATUS,
      };
      setFormData(newObj);
    } else {
      const objDefault = {
        FIMARCAATBID: 0,
        FCNOMBREMARCA: "",
        FIESTATUS: 1,
      };
      setFormData(objDefault);
    }
  }, [selectedItem, modalKey]);

  useEffect(() => {
    setErrors({});
  }, [selectedItem, modalKey]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "FCNOMBREMARCA" && value.length > 30) {
      setErrors((prevFormData) => ({
        ...prevFormData,
        FCNOMBREMARCA: "El nombre no debe exceder 30 caracteres.",
      }));
      return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const fetchHandleUpdateCancel = () => {
    setFormData(objDefault);
    setShowModal(false);
  };
  const fetchHandleUpdate = async () => {
    const errors = {};
    if (formData.FCNOMBREMARCA === "") {
      errors.FCNOMBREMARCA = "Ingresa el nombre";
    } else if (formData.FCNOMBREMARCA.length < 3 || formData.FCNOMBREMARCA.length > 30) {
      errors.FCNOMBREMARCA = "El nombre de marca debe tener entre 1 y 30 caracteres.";
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    } else {
      setErrors("");
    }
    setIsLoading(true);
    const onFailure = (error) => {
      //console.log("error", error);
      alert(error);
      setIsLoading(false);
    };

    const onSuccess = ({ data }) => {
      console.log(data);
      // eslint-disable-next-line no-lone-blocks
      if (data.statusCode === 200) {
        setFormData(objDefault);
        fetchData();
        setShowModal(false);
        setIsLoading(false);
        alert("Envio exitoso");
      } else {
        alert(data.error);
        setIsLoading(false);
      }
    };

    if (selectedItem) {
      PutFetchMarcaAtb(formData).then(onSuccess).catch(onFailure);
    } else {
      AddFetchMarcaAtb(formData).then(onSuccess).catch(onFailure);
    }
  };
  return (
    <Row justify="space-around">
      <Col span={24}>
        <div className="input-content-titulo">{selectedItem ? "Editar" : "Agregar"} Marca</div>
      </Col>
      <Col xs={24} md={22}>
        <InputForm
          handleChange={handleChange}
          value={formData.FCNOMBREMARCA}
          name={"FCNOMBREMARCA"}
          type={"text"}
          label={"Nombre"}
        />
        {errors && <div className="error-input-data">{errors.FCNOMBREMARCA}</div>}
      </Col>
      <Col xs={24} md={22}></Col>
      <Col xs={24} md={22}></Col>

      <div className="modal-footer-edith">
        <button
          onClick={fetchHandleUpdateCancel}
          type="submit"
          className="primary-button-cancel button-modal"
        >
          Cancelar
        </button>
        <button
          onClick={fetchHandleUpdate}
          type="submit"
          className={`button-modal ${isLoading ? "primary-button-disable" : "primary-button"}`}
          disabled={isLoading}
        >
          {isLoading ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </Row>
  );
};

